import styled, { css } from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.cardBg ?? theme.colors.white};
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight ?? "#E5E7EB"};
  box-shadow: 0 2px 12px rgba(16, 24, 64, 0.08);
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
  flex-shrink: 0;
`;



export const HeaderTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 12px;
`;

export const TabsAndControlsBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TabsRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  }
  
  
`;

export const TabLabelWithCaret = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;

  .anticon {
    font-size: 10px;
  }
`;

export const TableColGroup = styled.colgroup`
  col:nth-child(1) {
    width: 40%;
  }
  col:nth-child(2) {
    width: 60%;
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 18px 24px 24px;
  overflow: hidden;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.white} 0%,
    ${({ theme }) => theme.colors.light} 100%
  );
`;

export const RoleImpactDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
  height: 100%;
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;
`;

export const SectionTitle = styled.h4`
  font-size: 20px;
  line-height: 1.3;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
  margin: 0;
`;

export const SectionSubTitle = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.gray};
`;

export const OverallPotentialCard = styled.div`
  padding: 14px 16px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 14px;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.white} 0%,
    ${({ theme }) => theme.colors.light} 100%
  );
  box-shadow: 0 1px 2px ${({ theme }) => theme.colors.cardShadow};
`;

export const OverallPotentialRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const OverallPotentialLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
  white-space: nowrap;
`;

export const ProgressBarContainer = styled.div`
  display: flex;
  width: ${({ $compact }) => ($compact ? "100%" : "52%")};
  min-width: ${({ $compact }) => ($compact ? "unset" : "320px")};
  height: ${({ $compact }) => ($compact ? "26px" : "32px")};
  background: ${({ theme }) => theme.colors.borderLight};
  border-radius: 999px;
  overflow: hidden;
  box-shadow: inset 0 1px 2px ${({ theme }) => theme.colors.cardShadow};

  @media (max-width: 900px) {
    width: 100%;
    min-width: 0;
  }
`;

export const ProgressBarCurrent = styled.div`
  width: ${({ $width }) => `${$width}%`};
  min-width: ${({ $width }) =>
    (Number($width) || 0) > 0 ? "fit-content" : "0"};
  padding: ${({ $width }) => ((Number($width) || 0) > 0 ? "0 8px" : "0")};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.progressBarPeople};
  color: ${({ theme }) => theme.colors.white};
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
`;

export const ProgressBarAI = styled.div`
  width: ${({ $width }) => `${$width}%`};
  min-width: ${({ $width }) =>
    (Number($width) || 0) > 0 ? "fit-content" : "0"};
  padding: ${({ $width }) => ((Number($width) || 0) > 0 ? "0 8px" : "0")};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.progressBarAI};
  color: ${({ theme }) => theme.colors.dark};
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
`;

export const TasksTableWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;



`;

export const TableElement = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: ${({ theme }) => theme.colors.white};
`;

export const TableCol = styled.col`
  width: ${({ $width }) => $width || "auto"};
`;

export const TableHeadCell = styled.th`
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 0;
  text-align: left;
  background: ${({ theme }) => theme.colors.light};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
`;

export const SortHeaderButton = styled.button`
  width: 100%;
  padding: 14px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  user-select: none;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  transition: background 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.hoverBg};
  }
`;

export const SortHeaderLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: ${({ theme }) => theme.colors.dark};
`;

export const SortIcon = styled.span`
  position: relative;
  width: 12px;
  height: 14px;
  display: inline-block;
  flex-shrink: 0;
  opacity: ${({ $active }) => ($active ? 1 : 0.45)};

  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 2px;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
  }
  &::before {
    top: 1px;
    border-bottom: 5px solid
      ${({ $active, $direction, theme }) =>
        $active && $direction === "asc"
          ? theme.colors.primary
          : theme.colors.gray};
  }
  &::after {
    bottom: 1px;
    border-top: 5px solid
      ${({ $active, $direction, theme }) =>
        $active && $direction === "desc"
          ? theme.colors.primary
          : theme.colors.gray};
  }

  ${({ $direction, theme }) =>
    $direction === "both" &&
    css`
      &::before {
        border-bottom-color: ${theme.colors.gray};
      }
      &::after {
        border-top-color: ${theme.colors.gray};
      }
    `}
`;

export const TableBodyCell = styled.td`
  padding: 16px;
  font-size: 14px;
  vertical-align: top;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
  background: ${({ theme }) => theme.colors.white};
`;

export const TaskDescription = styled.div`
  font-size: 14px;
  line-height: 1.65;
  color: ${({ theme }) => theme.colors.dark};
  font-weight: 500;
`;

export const CollaborationPotentialCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ExpandButton = styled.button`
  width: 34px;
  height: 34px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.gray};
  flex-shrink: 0;
  transition: all 0.18s ease;
  padding: 0;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 4px 10px ${({ theme }) => theme.colors.hoverBg};
  }
`;

export const ChevronIcon = styled.span`
  width: 12px;
  height: 12px;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: ${({ $expanded }) =>
    $expanded ? "rotate(225deg)" : "rotate(45deg)"};
  transition: transform 0.2s ease;
  margin-top: ${({ $expanded }) => ($expanded ? "3px" : "-1px")};
`;

export const SpacerCell = styled.div`
  width: 34px;
  height: 34px;
  flex-shrink: 0;
`;

export const ExpandedRow = styled.tr`
  td {
    background: ${({ theme }) => theme.colors.light};
  }
`;

export const ExpandedContent = styled.td`
  padding: 18px 20px !important;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
`;

export const ExpandedContentInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ExpandedSectionTitle = styled.h6`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: ${({ theme }) => theme.colors.gray};
  text-transform: uppercase;
  margin: 0;
`;

export const WorkflowCard = styled.div`
  padding: 16px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 14px;
  box-shadow: 0 1px 2px ${({ theme }) => theme.colors.cardShadow};
`;

export const WorkflowCardHeader = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.dark};
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
`;

export const WorkflowCardContent = styled.div`
  font-size: 14px;
  line-height: 1.65;
  color: ${({ theme }) => theme.colors.gray};

  ol {
    margin: 0;
    padding-left: 20px;
    list-style: decimal;
  }
  li {
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors.dark};
  }
  li:last-child {
    margin-bottom: 0;
  }
`;

export const EmptyExpandState = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.gray};
`;

export const ComingSoonText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray};
  text-align: center;
  padding: 40px;
  margin: 0;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;
